export const inspectionOutcomeStatusIds: { [key: string]: string } = {
  noDefects: '1950d818-d348-46b1-87a1-e0a6b36b793a',
  defectsFixed: '72cec2ee-8fe3-4e13-971d-3f51f11d6968',
  unsafeScaffold: '48135324-c74a-4db4-9389-9df48095ea22',
  defectsNotFixed: '9800ecea-93a5-40a1-8463-1e5d5fbbce2e'
};
